import {Injectable} from '@angular/core';
import {ApiService} from '../api.service';
import {Observable} from 'rxjs';
import {ManageUserPayload, CreateUserResponse, UpdateUserResponse} from './user.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private readonly apiService: ApiService) {
  }

  public getUser(): Observable<any> {
    return this.apiService.get(`/user`);
  }

  public getUserById({userId, organizationId}): Observable<any> {
    return this.apiService.get(`/user/${organizationId}/user/${userId}`);
  }

  public getUsers(): Observable<any> {
    return this.apiService.get(`/users`);
  }

  public updateUser(userId: number, user: ManageUserPayload): Observable<UpdateUserResponse> {
    return this.apiService.put(`/user/${userId}`, user);
  }

  public createUser(user: ManageUserPayload): Observable<CreateUserResponse> {
    return this.apiService.post(`/user`, user);
  }

  public deleteUser(organizationId: number, userId: number): Observable<any> {
    return this.apiService.delete(`/user/${organizationId}/user/${userId}`);
  }

  public getUsersRoles(): Observable<any> {
    return this.apiService.get(`/roles`);
  }
}
